<template>
  <div class="search-modal">
    <div
      id="info"
      ref="image"
      class="image"
    >
      <Img
        :src="sight.cover_photo?.medium"
        :alt="sight.name"
        width="100%"
        height="100%"
        aspect-ratio="4 / 3"
      />
    </div>
    <ModalNav class="navbar" />
    <div class="sight-content">
      <SightInfo :sight="sight" />
      <SightPosition
        :sight="sight"
        :city="city"
      />
      <GuidesReview :sight="sight" />
      <Experience
        :key="sight.id"
        :sight="sight"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onBeforeUnmount, onMounted } from 'vue';

  import GuidesReview from '@/features/GuidesReview.vue';
  import ModalNav from '@/features/ModalNav.vue';
  import Experience from '@/features/SightExperience.vue';
  import SightInfo from '@/features/SightInfo.vue';
  import SightPosition from '@/features/SightPosition.vue';
  import { trackEvent } from '@/services/analytics';
  import { type City } from '@/shared/models/faq';
  import { type CityTagsAdvanced } from '@/shared/models/types';
  import Img from '@/shared/ui/ResponsiveImage.vue';
  import { useSightAnalyticsParams } from '@/shared/utils/analytics';

  const props = defineProps<{
    sight: CityTagsAdvanced;
    city: City;
  }>();

  const analyticsParams = useSightAnalyticsParams(() => props.sight);

  onMounted(() => {
    void trackEvent('attractions:sights:sight-popup.shown', analyticsParams.value);
  });

  onBeforeUnmount(() => {
    void trackEvent('attractions:sights:sight-popup.close', analyticsParams.value);
  });
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as legacy-typography;
  @use '@experience/shared/dist/assets/adaptivity' as legacy-adaptivity;

  .search-modal {
    position: relative;
  }

  .navbar {
    position: sticky;
    top: 72px;
    z-index: 9;

    @include legacy-adaptivity.tablet {
      top: 64px;
    }

    @include legacy-adaptivity.mobile {
      top: 60px;
    }
  }

  .sight-content {
    padding: 0 var(--alias-space-16);
  }

  .map {
    width: 100%;
    height: 343px;
    margin-top: var(--alias-space-16);
    overflow: hidden;
    border-radius: var(--alias-radius-8);
  }

  .map-btn {
    display: flex;
    gap: var(--alias-space-8);
    margin-top: var(--alias-space-8);
  }

  // .search-modal-header {
  //   position: fixed;
  //   top: 0;
  //   right: 0;
  //   left: 0;
  //   z-index: 9;
  //   width: 100%;
  //   padding: 18px 62px 16px 18px;
  //   background: var(--alias-color-background-default);

  //   @include legacy-typography.base-700-700-semi;

  //   @include legacy-adaptivity.mobile {
  //     @include legacy-typography.base-600-500-semi;
  //   }
  // }

  .image {
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 4/3;
    background-image: url('@/shared/assets/empty.jpg');
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>
